import { useQuery } from '@tanstack/react-query';
import type { Competitor, CursorPage } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useCompetitors(projectId: string | undefined) {
  return useQuery({
    queryKey: ['competitors', projectId],
    queryFn: () => apiGet<CursorPage<Competitor>>(`/v1/competitors?project_id=${projectId}`),
    enabled: !!projectId,
  });
}
